import { useQuery } from "@tanstack/react-query";
import { apiGateway } from "@/_old/services/api-gateway";
import { BookingsTimeSeries, BookingsTimeSeriesProps } from "../types";

export function useBookingsTimeSeries(props: BookingsTimeSeriesProps) {
  return useQuery({
    initialData: [] as BookingsTimeSeries[],
    queryKey: ["booking-stats-by-month", props],
    queryFn: async (): Promise<BookingsTimeSeries[]> => {
      const response = await apiGateway.get("/booking-stats-by-month", {
        params: props,
      });

      return response.data;
    },
    enabled: !!props.start_date && !!props.end_date && !!props.companyId,
  });
}
